import { render, staticRenderFns } from "./FonteSincronizadorC.vue?vue&type=template&id=d54f358c&scoped=true"
import script from "./FonteSincronizadorC.vue?vue&type=script&lang=js"
export * from "./FonteSincronizadorC.vue?vue&type=script&lang=js"
import style0 from "./FonteSincronizadorC.vue?vue&type=style&index=0&id=d54f358c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54f358c",
  null
  
)

export default component.exports